// extracted by css-extract-rspack-plugin
export default {"contentContainer":"contentContainer-eJskYP","mainContent":"mainContent-HbKUlV","bottomContent":"bottomContent-UEO2nc"};